import { render, staticRenderFns } from "./C_App_BottomBarMobile.vue?vue&type=template&id=6953c1d0&scoped=true&"
import script from "./C_App_BottomBarMobile.vue?vue&type=script&lang=js&"
export * from "./C_App_BottomBarMobile.vue?vue&type=script&lang=js&"
import style0 from "./C_App_BottomBarMobile.vue?vue&type=style&index=0&id=6953c1d0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6953c1d0",
  null
  
)

export default component.exports